<template>
<div class="page">
    <div class="loading-screen" v-if="status!='LOADED'">
        <div>
            <span class="spinner spinner--lg"></span>
            <span>loading answers…</span>
        </div>
    </div>
    <div v-else>
        <ExaminerNavBar />
        <div class="container container--narrow">
            <div class="page-head rise">
                <h1>Candidate Answers</h1>
                <p>Submitted code and test results, per question.</p>
            </div>

            <div v-if="answers.length==0" class="glass empty-state rise">
                <div class="empty-state__icon">🤷</div>
                <h2>Nothing here</h2>
                <p>This candidate has no stored answers for this exam.</p>
            </div>

            <div v-for="(answer, idx) in answers" :key="answer._id"
                 class="glass card mb-3 rise" :class="`rise-${Math.min(idx+1,4)}`">
                <h2 class="card__title">{{answer.question.name}}</h2>
                <div class="score-banner mt-3" style="font-size:0.95rem;padding:10px 14px">
                    <span>{{answer.testCasesPassed}} / {{answer.question.testCases.input.length}} test cases passed</span>
                    <div class="progress-track"><i :style="{width: (answer.testCasesPassed / answer.question.testCases.input.length * 100) + '%'}"></i></div>
                </div>
                <span class="card__meta">submitted code</span>
                <div class="code-block mt-2">{{answer.answer}}</div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import ExaminerNavBar from './ExaminerNavBar.vue';
import {getAnswer} from '../services/answers'
export default {
    name: 'AnswerPage',
    data () {
        return {
            status: '',
            answers: []
        }
    },
    methods: {
        async getAnswer() {
            try {
                const examId = this.$router.currentRoute.params.examId;
                const userId = this.$router.currentRoute.params.userId;
                const response = await getAnswer(examId, userId);
                this.answers = response.data;

                this.status = "LOADED";
            }
            catch (error) {
                this.status = "ERROR";
                this.error = error.message;
            }
        }
    },
    created() {
        this.getAnswer();
    },
    components: {
        ExaminerNavBar
    }
}
</script>
